export const onBlur = ({e, setFieldTouched, touched, key = null, value = null}) => {
  const name = key || e.target.id;
  setFieldTouched(name, touched[name] || !!(value || e.target.value), false);
}
